import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import {Breadcrumbs} from '../../components/breadcrumbs'
import {Layout} from '../../components/layout'
import {useBasketStore} from '../../store/hooks/useStore'
import {Box, Container, Stack} from '../../vanilla'
import {FreeDelivery} from './partials/free-delivery'
import {LetUsKnow} from './partials/let-us-know'
import {YourDelivery} from './partials/your-delivery'
import {BookingSlots} from './partials/booking-slots'
import {TObservablePage} from '../../types/commerce'
import {Seo} from '../../components/seo'
import {usePageDataTracking} from '../../analytics/page-tracking'
import useDeliveryBooking from '../../hooks/use-delivery-booking'

const BookDelivery: TObservablePage = () => {
  const {deliveryPostalCode, deliverySlotPostalCode} = useBasketStore()
  const {getDeliverySlots, loading} = useDeliveryBooking()

  const sendPageData = usePageDataTracking()
  const pageType = 'bookaslot'
  const pageCategory = 'Delivery'

  useEffect(() => {
    if (loading) return
    if (deliveryPostalCode || deliverySlotPostalCode !== deliveryPostalCode) {
      getDeliverySlots()
    }
  }, [deliveryPostalCode, deliverySlotPostalCode])

  useEffect(() => {
    sendPageData(pageType, pageCategory);
  }, [])

  return (
    <Layout>
      <Seo
        title="Book a Delivery Slot | Iceland Delivery"
        description=" Book a delivery slot with Iceland and receive your order at a time that suits you. Enjoy next day delivery when you spend £40 on your next basket. Iceland Foods"
      />
      <Container paddingX={['0px', '8px']}>
        <Box paddingX="8px" paddingY="12px">
          <Breadcrumbs breadcrumbs={[{id: 'BOOK_DELIVERY', name: 'Book your delivery'}]} />
        </Box>
        <Stack
          display={['flex', 'flex', 'grid']}
          gridColumnGap="20px"
          gridTemplateColumns={['1x', '1x', '12x']}
        >
          <YourDelivery />
          <Box display={['none', 'none', 'block']} gridColumn={['1', '1', 'span 5']}>
            <FreeDelivery />
          </Box>
          <BookingSlots />
          {deliveryPostalCode ? <LetUsKnow /> : null}
          <Box display={['block', 'block', 'none']} paddingBottom="20px">
            <FreeDelivery />
          </Box>
        </Stack>
      </Container>
    </Layout>
  )
}

export default observer(BookDelivery)
